import { useQuery } from '@tanstack/react-query';
import type { AxiosRequestConfig } from 'axios';
import { ENDPOINT } from '@constants/endpoint';
import axios from '@utils/axiosInstance';

const STALE_TIME_MS = 1000 * 60 * 10;

export const getTranslations = async (config?: AxiosRequestConfig) => {
  const { data } = await axios.get<{ [key: string]: string }>(
    ENDPOINT.TRANSLATIONS,
    {
      withToken: false,
      ...config,
    }
  );

  return data;
};

const useTranslations = (localeKey: string, options: { enabled: boolean }) =>
  useQuery({
    queryKey: ['apiTranslations', localeKey],
    queryFn: () => getTranslations({ headers: { 'X-LOCALE': localeKey } }),
    staleTime: STALE_TIME_MS,
    ...options,
  });

export default useTranslations;
